// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// import { variableAngular } from "../../../config/variableAngular";

/* ----------------------

  This is a config file for the : FRONT V2 DISTANT - DEV environment

---------------*/

const isLocal = false;

export const environment = {
  comparison: false,
  production: false,
  // for file access:
  isLocal,
  // for Parse db access: (distant if false)
  isLocalParse: false,
  isArnavaux: false,
  baseURL: '',
  portAPI: '3000',
  portClient: '4200',
  baseURLPictureLocal: ':1337/public/images/',
  parseAPILocal: ':1337/api',
  parseIDLocal: 'app',
  parseKEYLocal: 'q0DSMYvBDAA9CN5RlP4yVHDi6qGx2Wwv',
  baseURLPicture: 'https://tchek-content.s3.eu-west-3.amazonaws.com/',
  parseAPI: 'https://api.dev.tchek.io/private',
  parseID: 'Tchek',
  parseKEY: 'CVO8rRRPSTWZ5hRy8hxxiCZx1dGRGWri7LgbxSp3',
  parseLive: 'wss://api.dev.tchek.io/private',
  accessKeyId: '',
  secretAccessKey: '',
  urlProd: 'https://dev.tchek.fr/fr/',
  backAltoUrl: 'https://dev.alto.tchek.fr',
  frontV3Host: 'https://dev.webapp.tchek.fr',
  VERSION: require('../../package.json').version,
  /** @var {string} finalBaseURL ! DO NOT USE THIS, this.isLocal might not resolve to its real value */
  finalBaseURL: isLocal ? ':1337/public/images/' : 'https://tchek-content.s3.eu-west-3.amazonaws.com/',
  detectionFilename: 'pieces.json',
  thumbnailFilename: 'thumb.jpg'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts